import React from "react";
import loader from "../../assets/images/loader.gif";
const Loader = () => {
  return (
    <div className="sl__modal-inner">
      <div className="sl__modal--content">
        <div className="sl__modal--row">
          <img src={loader}></img>
        </div>
      </div>
    </div>
  );
};

export default Loader;
